<template>
  <!-- (5-5)医疗机构信息已认证信息修改页面Go! -->
  <div class="main-box-css">
    <div class="main-box">
      <p class="box-title">{{ $t("institutionalInformation") }}</p>
      <div class="from">
        <!-- 第一行 -->
        <div class="from-one-input">
          <div class="one-box">
            <div class="one-box-title">
              {{ $t("institutionName") }}<span>*</span>
            </div>
            <div class="one-input-css">
              <el-input
                v-model="inputData1"
                :placeholder="elInputInstitutionName"
                disabled
                @blur="inputData(1)"
                maxlength="100"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="from-one-input">
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("postCode") }}<span>*</span>
            </div>
            <div class="small-input-css">
              <el-input
                v-model="inputData2"
                :placeholder="elInputZipCode"
                @blur="inputData(2)"
                maxlength="32"
              ></el-input>
            </div>
          </div>
          <div class="one-box">
            <div class="one-box-title">{{ $t("location") }}<span>*</span></div>
            <div class="one-input-css">
              <el-input
                v-model="inputData3"
                :placeholder="elInputLocation"
                @blur="inputData(3)"
                maxlength="255"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="from-one-input">
          <div :class="disabled ? 'small-box-disabled ' : 'small-box'">
            <div class="small-box-title">
              {{ $t("institutionalAttributes") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ this.op }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in TableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div :class="disabled ? 'one-box-disabled ' : 'one-box'">
            <div class="one-box-title">{{ $t("hpOrSns") }}<span>*</span></div>
            <div class="one-input-css">
              <el-input
                v-model="inputData5"
                :placeholder="elInputHp"
                :disabled="disabled"
                @blur="inputData(4)"
                maxlength="255"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第四行 -->
        <div class="from-one-input">
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("representativeName") }}<span>*</span>
            </div>
            <div class="small-input-css">
              <el-input
                v-model="inputData6"
                :placeholder="enterRepresentative"
                @blur="inputData(5)"
                maxlength="255"
              ></el-input>
            </div>
          </div>
          <div class="one-box">
            <div class="one-box-title">
              {{ $t("institutionalNumber") }}<span>*</span>
            </div>
            <div class="one-input-css">
              <el-input
                v-model="inputData7"
                :placeholder="EnterPhoneNumber"
                @blur="inputData(6)"
                maxlength="20"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第五行 -->
        <div class="from-one-input">
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("registeredCapital") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown
                :disabled="disabled"
                @command="handleCommandCapitalAmount"
              >
                <span class="el-dropdown-link">
                  {{ this.opCapitalAmount
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in capitalAmountTableDate"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("numberStaff") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommandTeacher">
                <span class="el-dropdown-link">
                  {{ this.opTeacher
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in teacherTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("numberOfBets") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommandBed">
                <span class="el-dropdown-link">
                  {{ this.opBed
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in bedTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!-- 第六行 -->
        <div class="form-text-area">
          <div class="text-area-box">
            <div class="one-box-title">
              {{ $t("institutionalInformationMain") }}<span>*</span>
            </div>
            <div class="text-area-input">
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="institutionalPlaceholder"
                v-model="textarea"
                @blur="inputData(7)"
                maxlength="255"
              >
              </el-input>
            </div>
          </div>
        </div>
        <!-- button部分 -->
        <div class="form-button">
          <button @click="audit">{{ $t("toEdit") }}</button>
        </div>
        <!-- 头像部分 -->
        <div class="Avatar">
          <div class="Avatar-img" @click="toGetImg" v-if="!imageUrl">
            <p class="Avatar-img-icon">
              <img src="./assets/Image_01.svg" alt="" />
            </p>
            <p class="Avatar-img-title">{{ $t("LogImage") }}</p>
          </div>
          <div class="Avatar-img" @click="toGetImg" v-if="imageUrl">
            <img :src="imageUrl" alt="" class="Avatar-img-main-css" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import AES from "../../js/AES";
import { editBasicInfo, getUrlFromOSS, queryBasicInfo } from "../../js/api";
export default {
  name: "educationalCertificationRevise",
  components: {},
  data() {
    return {
      op: "",
      opTeacher: "",
      opBed: "",
      opCapitalAmount: "",
      bedTableData: [],
      TableData: [],
      teacherTableData: [],
      capitalAmountTableDate: [],
      searchData: "", //搜索内容
      imageUrl: "", //头像图片地址路径
      inputData1: "", //機関名input
      inputData2: "", //郵便番号input
      inputData3: "", //所在地input
      inputData4: "", //代表者氏名input
      inputData5: "", //機関の電話番号input
      inputData6: "", //HP or SNSinput
      inputData7: "",
      inputData8: "",
      inputData9: "",
      inputData10: "",
      textarea: "", //文本框内容
      disabled: false, //禁用状态
      lodePageData: {}, //上个页面传回的数据
      loadRole: "", //上个页面传回的角色标识
      language: "",
      avatar: ""
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.staffNumber();
    this.select();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    }, //搜索部分的placeholder
    elInputInstitutionName() {
      return this.$t("forNewEnterContents");
    },

    elInputZipCode() {
      return this.$t("enterZipCode");
    },

    elInputLocation() {
      return this.$t("enterAddress");
    },

    elInputHp() {
      return this.$t("homepageEtc");
    },

    enterRepresentative() {
      return this.$t("enterRepresentative");
    },

    EnterPhoneNumber() {
      return this.$t("EnterPhoneNumber");
    },
    clinic() {
      return this.$t("clinic");
    },
    generalHospital() {
      return this.$t("generalHospital");
    },
    communityMedicalHospital() {
      return this.$t("communityMedicalHospital");
    },
    specialFunctionHospital() {
      return this.$t("specialFunctionHospital");
    },
    paidNursingHome() {
      return this.$t("paidNursingHome");
    },
    housingElderly() {
      return this.$t("housingElderly");
    },
    groupHome() {
      return this.$t("groupHome");
    },
    careHouse() {
      return this.$t("careHouse");
    },
    specialElderlyNursing() {
      return this.$t("specialElderlyNursing");
    },
    longTermCare() {
      return this.$t("longTermCare");
    },
    longTermFacility() {
      return this.$t("longTermFacility");
    },
    institutionalPlaceholder(){
      return this.$t("institutionalPlaceholder");
    },
  },
  methods: {
    // input校验
    inputData(num) {
      /*
        inputWord1:"机构名称输入字数超过限制100位",2
        inputWord2:"番号输入字数超过限制32位",     3
        inputWord3:"地址输入字数超过限制255位",     1
        inputWord4:"HP输入字数超过限制255位",        1
        inputWord5:"代表者姓名输入字数超过限制255位",   1
        inputWord6:"机构电话输入字数超过限制20位",       4
        inputWord7:"机构简介输入字数超过限制255位",       1
     */
      var vc1 = /^.{1,224}$/;
      var vc2 = /^.{1,99}$/;
      var vc3 = /^.{1,31}$/;
      var vc4 = /^.{1,19}$/;

      if (num === 1) {
        //机构名验证
        if (vc2.test(this.inputData1)) {
          console.log("机构名验证");
          console.log(this.inputData1);
          this.intercept1 = 0;
        } else {
          this.intercept1 = 1;
          this.$message({
            message: this.$t("inputWord1"),
            type: "warning"
          });
        }
      } else if (num === 2) {
        //番号验证
        if (vc3.test(this.inputData2)) {
          console.log("番号验证");
          console.log(this.inputData2);
          this.intercept2 = 0;
        } else {
          this.intercept2 = 1;
          this.$message({
            message: this.$t("inputWord2"),
            type: "warning"
          });
        }
      } else if (num === 3) {
        //地址验证
        if (vc1.test(this.inputData3)) {
          console.log("地址验证");
          console.log(this.inputData3);
          this.intercept3 = 0;
        } else {
          this.intercept3 = 1;
          this.$message({
            message: this.$t("inputWord3"),
            type: "warning"
          });
        }
      } else if (num === 4) {
        //HP 验证
        if (vc1.test(this.inputData5)) {
          console.log("HP验证");
          console.log(this.inputData5);
          this.intercept4 = 0;
        } else {
          this.intercept4 = 1;
          this.$message({
            message: this.$t("inputWord4"),
            type: "warning"
          });
        }
      } else if (num === 5) {
        //代表者姓名 验证
        if (vc1.test(this.inputData6)) {
          console.log("代表者姓名 验证");
          console.log(this.inputData6);
          this.intercept5 = 0;
        } else {
          this.intercept5 = 1;
          this.$message({
            message: this.$t("inputWord5"),
            type: "warning"
          });
        }
      } else if (num === 6) {
        //机构电话 验证
        if (vc4.test(this.inputData7)) {
          console.log("机构电话验证");
          console.log(this.inputData7);
          this.intercept6 = 0;
        } else {
          this.intercept6 = 1;
          this.$message({
            message: this.$t("inputWord6"),
            type: "warning"
          });
        }
      } else if (num === 7) {
        //机构简介验证
        if (vc1.test(this.textarea)) {
          console.log("机构简介验证");
          console.log(this.textarea);
          this.intercept7 = 0;
        } else {
          this.intercept7 = 1;
          this.$message({
            message: this.$t("inputWord7"),
            type: "warning"
          });
        }
      }
    },
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据4------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.staffNumber();
      }
    },
    audit() {
      if (
        this.inputData1 === "" ||
        this.inputData2 === "" ||
        this.inputData3 === "" ||
        this.inputData4 === "" ||
        this.inputData5 === "" ||
        this.inputData6 === "" ||
        this.inputData7 === "" ||
        this.textarea === "" 
        
        // ||this.imageUrl === ""
      ) {
        this.$alert(this.$t("dataMiss"), this.$t("enterZipCode"), {
          confirmButtonText: this.$t("confirm") ,
          callback: action => {
            this.$message({
              type: "info",
              message: this.$t("question")
            });
          }
        });
      } else if (
        this.intercept1 === 1 ||
        this.intercept2 === 1 ||
        this.intercept3 === 1 ||
        this.intercept4 === 1 ||
        this.intercept5 === 1 ||
        this.intercept6 === 1 ||
        this.intercept7 === 1
      ) {
        if (this.intercept1 === 1) {
          this.$message({
            message: this.$t("inputWord1"),
            type: "warning"
          });
        }
        if (this.intercept2 === 1) {
          this.$message({
            message: this.$t("inputWord2"),
            type: "warning"
          });
        }
        if (this.intercept3 === 1) {
          this.$message({
            message: this.$t("inputWord3"),
            type: "warning"
          });
        }
        if (this.intercept4 === 1) {
          this.$message({
            message: this.$t("inputWord4"),
            type: "warning"
          });
        }
        if (this.intercept5 === 1) {
          this.$message({
            message: this.$t("inputWord5"),
            type: "warning"
          });
        }
        if (this.intercept6 === 1) {
          this.$message({
            message: this.$t("inputWord6"),
            type: "warning"
          });
        }
        if (this.intercept7 === 1) {
          this.$message({
            message: this.$t("inputWord7"),
            type: "warning"
          });
        }
      } else {
        this.update();
      }
    },
    //图片回显
    getUrl(url) {
      console.log("url" + url);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.imageUrl = aesFecInfo.message;
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //获取员工数下拉框选项
    staffNumber() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpemployeeNumber";
      } else {
        dataItems = "employeeNumber";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.teacherTableData = aesFecInfo.data;
            console.log(that.teacherTableData, "65116");
            that.bedNumber();
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
            that.bedNumber();
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //床位下拉框获取
    bedNumber() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpbedNumber";
      } else {
        dataItems = "bedNumber";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.bedTableData = aesFecInfo.data;
            console.log(that.bedTableData);
            that.jpEducationAttributes();
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
            that.jpEducationAttributes();
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //机构属性下拉框获取
    jpEducationAttributes() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpmedicalAttributes";
      } else {
        dataItems = "medicalAttributes";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.TableData = aesFecInfo.data;
            console.log(that.TableData);
            that.capitalAmount();
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
            that.capitalAmount();
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //资本金下拉框获取
    capitalAmount() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpcapitalAmount";
      } else {
        dataItems = "capitalAmount";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.capitalAmountTableDate = aesFecInfo.data;
            console.log(that.capitalAmountTableDate);
            var userInfo = localStorage.getItem("userInfo");
            const userinfo = JSON.parse(AES.decrypt(userInfo));
            var status = userinfo.userStatus;
            if (status === 0) {
              that.select();
            } else {
              that.selects();
            }
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
            var userInfo = localStorage.getItem("userInfo");
            const userinfo = JSON.parse(AES.decrypt(userInfo));
            var status = userinfo.userStatus;
            if (status === 0) {
              that.select();
            } else {
              that.selects();
            }
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //床位人数下拉框
    handleCommandBed(e) {
      this.inputData10 = e.code;
      this.opBed = e.name;
      console.log(e);
    },
    //老师下拉框
    handleCommandTeacher(e) {
      this.inputData9 = e.code;
      this.opTeacher = e.name;
      console.log(e);
    },
    //机关属性下拉框
    handleCommand(e) {
      this.inputData4 = e.code;
      this.op = e.name;
      console.log(e);
    },
    //资本金下拉框
    handleCommandCapitalAmount(e) {
      this.inputData8 = e.code;
      this.opCapitalAmount = e.name;
      console.log(e);
    },
    select() {
      queryBasicInfo()
        .then(res => {
          console.log("select");
          console.log(res);
          if (res.data.code === "A0000") {
            let aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo)
            aesFecInfo = aesFecInfo.data[0];
            this.inputData3 = aesFecInfo.address;
            this.inputData4 = aesFecInfo.attributes;
            this.inputData5 = aesFecInfo.hpOrSns;
            this.inputData1 = aesFecInfo.medicalName;
            this.textarea = aesFecInfo.introduction;
            this.inputData6 = aesFecInfo.legalPerson;
            this.inputData2 = aesFecInfo.postNumber;
            this.inputData7 = aesFecInfo.telephone;
            this.inputData8 = aesFecInfo.capitalAmount;
            this.inputData9 = aesFecInfo.employeeNumber;
            this.inputData10 = aesFecInfo.bedNumber;
            this.imageUrl = aesFecInfo.avatarAddress;
            console.log("开始回显");
            if (this.imageUrl === "" || this.imageUrl === null) {
              console.log("回显失败");
            } else {
              this.getUrl(this.imageUrl);
            }
            for (var j = 0; j < this.TableData.length; j++) {
              if (aesFecInfo.attributes == this.TableData[j].code) {
                this.op = this.TableData[j].name;
                console.log(this.op);
              }
            }
            for (var j = 0; j < this.bedTableData.length; j++) {
              if (aesFecInfo.bedNumber == this.bedTableData[j].code) {
                this.opBed = this.bedTableData[j].name;
              }
            }
            for (var j = 0; j < this.teacherTableData.length; j++) {
              if (aesFecInfo.employeeNumber == this.teacherTableData[j].code) {
                this.opTeacher = this.teacherTableData[j].name;
              }
            }
            for (var j = 0; j < this.capitalAmountTableDate.length; j++) {
              if (
                aesFecInfo.capitalAmount == this.capitalAmountTableDate[j].code
              ) {
                this.opCapitalAmount = this.capitalAmountTableDate[j].name;
              }
            }
          } else {
            this.$message.error("登录失败。");
          }
        })
        .catch(res => {});
    },
    selects() {
      axios
        .get("/api/modules-parent/advancedAuth/getAuthOrganInfo", {
          params: {},
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(res => {
          console.log("select");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo, "45");
            this.inputData3 = aesFecInfo.address;
            this.inputData4 = aesFecInfo.attributes;
            this.inputData5 = aesFecInfo.hpOrSns;
            this.inputData1 = aesFecInfo.educationName;
            this.textarea = aesFecInfo.introduction;
            this.inputData6 = aesFecInfo.legalPerson;
            this.inputData2 = aesFecInfo.postNumber;
            this.inputData7 = aesFecInfo.telephone;
            this.inputData8 = aesFecInfo.capitalAmount;
            this.inputData9 = aesFecInfo.employeeNumber;
            this.inputData10 = aesFecInfo.bedNumber;
            this.imageUrl = aesFecInfo.avatarAddress;
            if (this.imageUrl === "" || this.imageUrl === null) {
              console.log("回显失败");
            } else {
              this.getUrl(this.imageUrl);
            }
            for (var j = 0; j < this.TableData.length; j++) {
              if (aesFecInfo.attributes == this.TableData[j].code) {
                this.op = this.TableData[j].name;
                console.log(this.op);
              }
            }
            for (var j = 0; j < this.bedTableData.length; j++) {
              if (aesFecInfo.bedNumber == this.bedTableData[j].code) {
                this.opBed = this.bedTableData[j].name;
              }
            }
            for (var j = 0; j < this.teacherTableData.length; j++) {
              if (aesFecInfo.employeeNumber == this.teacherTableData[j].code) {
                this.opTeacher = this.teacherTableData[j].name;
              }
            }
            for (var j = 0; j < this.capitalAmountTableDate.length; j++) {
              if (
                aesFecInfo.capitalAmount == this.capitalAmountTableDate[j].code
              ) {
                this.opCapitalAmount = this.capitalAmountTableDate[j].name;
              }
            }
          } else {
            this.$message.error("登录失败。");
          }
        })
        .catch(res => {});
    },
    //修改
    update() {
      var basicInfoDTO = {
        address: this.inputData3,
        attributes: this.inputData4,
        hpOrSns: this.inputData5,
        institutionName: this.inputData1,
        introduction: this.textarea,
        legalPerson: this.inputData6,
        postNumber: this.inputData2,
        employeeNumber: this.inputData9,
        capitalAmount: this.inputData8,
        bedNumber: this.inputData10,
        telephone: this.inputData7,
        avatarAddress: this.avatar||this.imageUrl||''
      };
      console.log(basicInfoDTO);
      axios({
        method: "post",
        url: "/api/modules-parent/advancedAuth/updateInstitutionInfo",
        data: basicInfoDTO,
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(res => {
          if (res.data.code === "A0000") {
            this.$router.push({
              path: "/underReview"
            });
          } else {
            console.log(res);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //上传图片
    toGetImg() {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 2;
        const size = files.size / 1024 / 1024;
        console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error(this.$t("imageSize"));
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error(this.$t("selectImage"));
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.imageUrl = this.result;
            console.log(this.result);
            // 数据传到后台
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            console.log(formData.get("file"));
            axios
              .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                headers: {
                  //头部参数
                  "Content-Type": "multipart/form-data",
                  token: localStorage.getItem("token")
                }
              })
              .then(function(res) {
                //请求成功
                if (res.data.code === "200 OK") {
                  console.log("-----上传图片参数-----");
                  console.log(res);
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  that.avatar = aesFecInfo.path;
                  that.imageUrl = aesFecInfo.url;
                }
              })
              .catch(function(error) {
                //请求失败
                console.log(error);
              });
          };
        }
      }
    }
  }
};
</script>
<style scoped>
.main-box-css {
  width: 100%;
  height: 100%;
}
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 35px 0;
  box-sizing: border-box;
}
.main-box {
  /* height: 100%; */
  width: 700px;
  /* margin-left: 450px; */
  margin: auto;
  padding-bottom: 70px;
  position: relative;
}
.box-title {
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  height: 34px;
  color: #686868;
  text-align: center;
  margin-bottom: 50px;
  margin-top: 24px;
}
.search {
  height: 35px;
  padding: 0 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}

.from-one-input {
  height: 50px;
  padding: 0 0 0 40px;
  box-sizing: border-box;
  margin-top: 20px;
  display: flex;
}
.one-box {
  width: 416px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.one-box-title {
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  box-sizing: border-box;
  position: absolute;
  top: -12px;
  left: 15px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
  z-index: 20;
}
.one-box-title span {
  color: #da1414;
}
.one-input-css /deep/ .el-input {
  width: 400px;
  height: 40px;
  margin-left: 5px;
}
.one-input-css /deep/ .el-input__inner {
  border: 1px solid transparent;
}
.small-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 20px;
}

.small-box-title {
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  box-sizing: border-box;
  position: absolute;
  top: -12px;
  left: 15px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
  z-index: 20;
}
.small-box-title span {
  color: #da1414;
}
.small-input-css /deep/ .el-input {
  width: 180px;
  height: 40px;
  /* margin-left: 5px; */
}
.small-input-css /deep/ .el-input__inner {
  border: 1px solid transparent;
}
.inline-box-dropdown {
  height: 40px;
  line-height: 45px;
  overflow: hidden;
}
.el-dropdown-link {
  width: 180px;
  display: inline-block;
  padding: 0 0 0 15px;
  box-sizing: border-box;
}
.inline-box-dropdown i {
  float: right;
  margin-top: 15px;
  font-weight: 700;
}
.form-text-area {
  height: 178px;
  padding: 0 0 0 40px;
  box-sizing: border-box;
  margin-top: 20px;
}
.text-area-box {
  width: 640px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.text-area-input {
  margin-top: 10px;
}
.text-area-input /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 160px;
}
.form-button {
  text-align: center;
  margin-top: 37px;
}
.form-button button {
  height: 40px;
  line-height: 40px;
  width: 150px;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.Avatar {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 45px;
  right: 75px;
}
.Avatar-img {
  width: 90px;
  height: 90px;
  background: #51abff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
}
.Avatar-img-icon {
  margin-top: 15px;
}
.Avatar-img-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.Avatar-img .Avatar-img-main-css {
  width: 90px;
  height: 90px;
}

.one-box .inline-box-dropdown {
  line-height: 44px;
  height: 44px;
  overflow: hidden;
}
.one-box .el-dropdown-link {
  width: 400px;
  display: inline-block;
  padding: 0 0 0 15px;
  box-sizing: border-box;
}
.one-box .inline-box-dropdown i {
  float: right;
  margin-top: 15px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalCertificationModification/index.vue